import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SnackService } from "app/shared/services/snack-service.service";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { ArticlePlanner } from "../models/article-planner.model";
import { Article, ArticleInfos } from "../models/article.model";
import { safeFirstValueFrom } from "../../../shared/utils/safe-first-value-from";

@Injectable({ providedIn: "root" })
export class ArticlesService {
  private _articles$ = new BehaviorSubject<Article[]>([]);
  private _articleSaving$ = new BehaviorSubject<boolean>(false);
  private _articleSaved$ = new BehaviorSubject<boolean>(false);
  public _currentArticle$ = new BehaviorSubject<Article>(null);
  private _currentPlanner$ = new BehaviorSubject<ArticlePlanner>(null);

  public articles$: Observable<Article[]> = this._articles$.asObservable();
  public currentArticle$: Observable<Article> =
    this._currentArticle$.asObservable();
  public currentPlanner$: Observable<ArticlePlanner> =
    this._currentPlanner$.asObservable();
  public articleSaving$: Observable<boolean> =
    this._articleSaving$.asObservable();
  public articleSaved$: Observable<boolean> =
    this._articleSaved$.asObservable();

  constructor(
    private http: HttpClient,
    private snackService: SnackService,
  ) {}

  importWithLot(resArticles) {
    this.http
      .post(`${environment.api()}/lot_mouvements/importWithLot`, {
        payload: resArticles,
      })
      .subscribe((_) => {
        this.snackService.success(`Done`);
      });
  }

  loadAll(): void {
    this.http
      .get<Article[]>(`${environment.api()}/articles/`)
      .subscribe((articles) => {
        this._articles$.next(articles);
      });
  }

  loadGraphInfo() {
    return this.http.get<Article[]>(`${environment.api()}/articles/graph/data`);
  }

  loadById_(id: string) {
    return this.http.get<Article>(`${environment.api()}/articles/id/${id}`);
  }

  loadPlannerFor(id: string) {
    this.http
      .get<ArticlePlanner>(`${environment.api()}/lots/planner/${id}`)
      .subscribe((planner) => {
        this._currentPlanner$.next(planner);
      });
  }

  setCurrent(a: Article): void {
    this._currentArticle$.next(a);
  }

  import(payload: any) {
    this._articleSaving$.next(true);
    return this.http.post(`http://localhost:3000/api/articles/import`, payload);
    //.subscribe((savedArticles: Article[]) => {
    //  this._articleSaving$.next(false);
    //  this._articleSaved$.next(true);
    //  this.loadAll();
    //  //this.refreshFor(savedArticle, "save");
    //this.snackService.success(`${savedArticles.length} articles enregistrés`);
    //});
  }

  delete(a: Article): void {
    this._articleSaving$.next(true);
    this.http.delete(`${environment.api()}/articles/${a.id}`).subscribe(
      (deletedArticle: Article) => {
        this._articleSaving$.next(false);
        this.loadAll();
        //this.refreshFor(savedArticle, "delete");
        this.snackService.success(`Article supprimé`);
      },
      (err) => {
        this._articleSaving$.next(false);
      },
    );
  }

  updateCurrentArticleInfos_(articleId: string, ean13: string, ean14: string) {
    return this.http.post<ArticleInfos>(
      `${environment.api()}/specification_etape/infosArticle/update`,
      { articleId, ean13, ean14 },
    );
  }

  async saveInfos(a: ArticleInfos) {
    this._articleSaving$.next(true);
    this._articleSaved$.next(false);
    const infos = await safeFirstValueFrom(
      this.http.post<ArticleInfos>(
        `${environment.api()}/specification_etape/infosArticle`,
        a,
      ),
    );
    this._articleSaving$.next(false);
    this._articleSaved$.next(true);
    this._articleSaved$.next(false);
    this.snackService.success(`Infos enregistrées`);
    return infos;
  }
}
